export enum OrganizationType {
  ADMINISTRATION = "ADMINISTRATION",
  OPERATOR = "OPERATOR",
}
